import React, { useEffect, useRef, useState, useContext } from "react";

import { Button } from "primereact/button";
import { Toast } from "primereact/toast";

import Card from "../../Base/Components/Card/Card";
import { getLabel } from "../../Base/Services/Language/LanguageService";
import { baseLang } from "../../Base/Lang/BaseLang";
import { ConfigContext } from "../../Base/Context/ConfigContext/ConfigContext";
import { AuthContext } from "../../Base/Context/AuthContext/AuthContext";
import AgGrid from "../../Base/Components/Tables/AgGrid/AgGrid";
import { setTitlePage } from "../../Base/Services/Config/ConfigService";
import { toastShow } from "../../Base/Services/ToastService";
import DialogPassword from "../../Base/Components/Dialog/DialogPassword/DialogPassword";
import { encryptor } from "../../Base/Services/Crypto/Crypto";

import { getNotasCredito, verifyPassword } from "../../API/Imex/imexReques";

const NotasCreditoScreen = () => {
    const toast = useRef(null);
    const { config } = useContext(ConfigContext);
    const { userAuth } = useContext(AuthContext);

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [dataSend, setDataSend] = useState([]);
    const [firma, setFirma] = useState([]);
    const [selected, setSelected] = useState([]);
    const [password, setPassword] = useState(null);
    const [showDialogPassword, setShowDialogPassword] = useState(false);

    const getInfo = async () => {
        setLoading(true);
        const dataTempo = await getNotasCredito();
        setData(dataTempo);
        setLoading(false);
    };

    const handleCheckboxChange = async (data, firma) => {
        setShowDialogPassword(true)
        setFirma(firma);
        setDataSend(data);
    }

    const agregarFirma = async () => {
        if (!password) {
            toastShow(toast, "warn", "Advertencia", "Debe ingresar la contraseña");
            return;
        }
    
        let passworEncrypted = await encryptor(password);
    
        const cards = dataSend.map(item => {
            return {
                IdCheck: item.Id,
                Depto: firma
            };
        })

        let ver = {
            IdUser: userAuth.idUser,
            Password: passworEncrypted,
            Usuario: userAuth.Usuario,
            Cards: cards,
        }
        const t = await verifyPassword(ver);

        setTimeout(() => {
            if(t?.isValid){
                setShowDialogPassword(false);
                getInfo()
                setSelected([])
                setPassword(null)
                toastShow(toast, "success", "Firma Agregada", t?.mensajes);
            }else{
                toastShow(toast, "error", "Error", 'Error al firmas la solicitud');
            }
        }, 700);

    };
    

    const columns = [
        {
            field: "Id",
            header: "ID",
            headerEn: "ID",
            frozen: "frozen",
            hidden: userAuth.IdRol === 1,
            className: "XXsmall",
            onCellDoubleClicked: ({ data }) => {
                setSelected(data);
            },
        },
        {
            field: "FechaCreacion",
            header: "Fecha",
            headerEn: "Date",
            className: "medium",
            body: (rowData) => rowData.FechaCreacion,
            className: "small",
            Format: 'DateTime'
        },
        {
            field: "Correlativo",
            header: "Correlativo",
            headerEn: "Correlative",
            className: "Xsmall",
            Format: 'Modal',
            onCellDoubleClicked: ({ data }) => {
                setSelected(data);
            },
        },
        {
            field: "Solicitante",
            header: "Solicitante",
            headerEn: "Solicitante",
            className: "small",
            onCellDoubleClicked: ({ data }) => {
                setSelected(data);
            },
        },
        {
            field: "NumeroFactura",
            header: "Factura",
            headerEn: "Invoice",
            className: "medium",
            onCellDoubleClicked: ({ data }) => {
                setSelected(data);
            },
        },
        {
            field: "Cliente",
            header: "Cliente",
            headerEn: "Customer",
            className: "large",
            onCellDoubleClicked: ({ data }) => {
                setSelected(data);
            },
        },
        {
            field: "Lotes",
            header: "Lotes",
            headerEn: "Lotes",
            className: "Xsmall",
            Sumary: "sum",
            Format: "Currency",
            onCellDoubleClicked: ({ data }) => {
                setSelected(data);
            },
        },
        {
            field: "Rollos",
            header: "Rollos",
            headerEn: "Rollos",
            Format: "Currency",
            Sumary: "sum",
            className: "Xsmall",
            onCellDoubleClicked: ({ data }) => {
                setSelected(data);
            },
        },
        {
            field: "Kgs",
            header: "Kgs",
            headerEn: "Kgs",
            Sumary: "sum",
            Format: "Currency",
            className: "Xsmall",
            onCellDoubleClicked: ({ data }) => {
                setSelected(data);
            },
        },
        {
            field: "Yds",
            header: "Yds",
            Sumary: "sum",
            headerEn: "Yds",
            Format: "Currency",
            className: "Xsmall",
            onCellDoubleClicked: ({ data }) => {
                setSelected(data);
            },
        },
        {
            field: "Lbs",
            header: "Lbs",
            Sumary: "sum",
            headerEn: "Lbs",
            Format: "Currency",
            className: "Xsmall",
            onCellDoubleClicked: ({ data }) => {
                setSelected(data);
            },
        },
        {
            field: "Monto",
            header: "Monto",
            Sumary: "sum",
            headerEn: "Amount",
            Format: "Currency",
            className: "Xsmall",
            onCellDoubleClicked: ({ data }) => {
                setSelected(data);
            },
        },
        {
            field: "Comentario",
            header: "Comentario",
            headerEn: "Comment",
            className: "XXXXlarge",
            onCellDoubleClicked: ({ data }) => {
                setSelected(data);
            },
        },
        {
            field: "Solicita",
            header: "Solicita",
            headerEn: "Solicita",
            Format: 'Checkbox',
            frozen: "frozen",
            alignFrozen: "right",
            onChange: (event, { data }) => {
                const filteredSelected = selected?.filter(item => item?.Solicita === false);
                const filterData = [data].filter(item => item?.Solicita === false);

                let info = selected.length === 0 ? filterData : filteredSelected;
                if (info?.length === 0) {
                    toastShow(toast, "warn", "Advertencia", 'Las Notas de Crédito seleccionadas ya fueron firmadas')
                    return;
                }

                let dataFiltrada = info.filter(item => item?.IdSolicita === userAuth?.IdUser);
                
                if (dataFiltrada.length === 0 && userAuth?.IdRol !== 1) {
                    toastShow(toast, "error", "Error", info?.length > 1 ? 'No tiene acceso a firmar las notas de Crédito seleccionadas' : 'No tiene acceso a firmar la nota de Crédito seleccionada')
                    return;
                }
                let dataEnviar = userAuth?.IdRol === 1 ? info : dataFiltrada;
                handleCheckboxChange(dataEnviar, 'Solicita');
            },
        },
        {
            field: "Ventas",
            header: "Ventas",
            headerEn: "Ventas",
            Format: 'Checkbox',
            frozen: "frozen",
            alignFrozen: "right",
            disabled: userAuth?.idUser === 22 || userAuth?.IdRol === 1,
            onChange: (event, { data }) => {
                const filteredSelected = selected?.filter(item => item?.Ventas === false);
                const filterData = [data].filter(item => item?.Ventas === false);

                let info = selected.length === 0 ? filterData : filteredSelected;

                if (info?.length === 0) {
                    toastShow(toast, "warn", "Advertencia", 'Las Notas de Crédito seleccionadas ya fueron firmadas')
                    return;
                }
                if(userAuth?.idUser !== 22 && userAuth?.IdRol !== 1){
                    toastShow(toast, "error", "Error", info?.length >  1 ? 'No tiene acceso a firmar las notas de Crédito seleccionadas' : 'No tiene acceso a firmar la nota de Crédito seleccionada')
                    return;
                }

                handleCheckboxChange(info, 'Ventas');
            },
        },
        {
            field: "Finanzas",
            header: "Finanzas",
            headerEn: "Finanzas",
            Format: 'Checkbox',
            frozen: "frozen",
            alignFrozen: "right",
            disabled: userAuth?.idUser === 22 || userAuth?.IdRol === 1,
            onChange: (event, { data }) => {
                const filteredSelected = selected?.filter(item => item?.Finanzas === false);
                const filterData = [data].filter(item => item?.Finanzas === false);

                let info = selected.length === 0 ? filterData : filteredSelected;

                if (info?.length === 0) {
                    toastShow(toast, "warn", "Advertencia", 'Las Notas de Crédito seleccionadas ya fueron firmadas')
                    return;
                }
                if(userAuth?.idUser !== 83 && userAuth?.IdRol !== 1){
                    toastShow(toast, "error", "Error", info?.length >  1 ? 'No tiene acceso a firmar las notas de Crédito seleccionadas' : 'No tiene acceso a firmar la nota de Crédito seleccionada')
                    return;
                }

                handleCheckboxChange(info, 'Finanzas');
            },
        },
        {
            field: "GteProduccion",
            header: "GteProduccion",
            headerEn: "GteProduccion",
            Format: 'Checkbox',
            frozen: "frozen",
            alignFrozen: "right",
            disabled: userAuth?.idUser === 231 || userAuth?.IdRol === 1,
            onChange: (event, { data }) => {
                const filteredSelected = selected?.filter(item => item?.GteProduccion === false);
                const filterData = [data].filter(item => item?.GteProduccion === false);

                let info = selected.length === 0 ? filterData : filteredSelected;

                if (info?.length === 0) {
                    toastShow(toast, "warn", "Advertencia", 'Las Notas de Crédito seleccionadas ya fueron firmadas')
                    return;
                }
                if(userAuth?.idUser !== 231 && userAuth?.IdRol !== 1){
                    toastShow(toast, "error", "Error", info?.length >  1 ? 'No tiene acceso a firmar las notas de Crédito seleccionadas' : 'No tiene acceso a firmar la nota de Crédito seleccionada')
                    return;
                }

                handleCheckboxChange(info, 'GteProduccion');
            },
        },
        {
            field: "Estado",
            body: (rowData) => ({ ID: rowData.IdEstado, Estado: rowData.Estado }),
            header: "Estado",
            headerEn: "Status",
            className: "Xsmall",
            Format: "Estado",
            frozen: "frozen",
            alignFrozen: "right",
        },
        {
            field: "Tipo",
            header: "Tipo",
            headerEn: "Type",
            className: "small",
            frozen: "frozen",
            alignFrozen: "right",
        },

    ];

    const table = {
        Columns: columns,
        Data: data,
        loading: loading,
        selected: selected,
        setSelected: setSelected,
    };

    useEffect(() => {
        setTitlePage(getLabel(baseLang, "AutorizarNota", config.language));
        getInfo();
    }, []);

    return (
        <div
            className=" p-fluid px-4"
            style={{ width: "100%", height: "100%", margin: "auto" }}
        >
            <Toast ref={toast} />
            <Card
                titulo={
                    <div className="botones">
                        <h3>{getLabel(baseLang, "AutorizarNota", config.language)}</h3>
                        <Button icon="pi pi-refresh" onClick={getInfo} />
                    </div>
                }
                contenido={
                    <div className="p-4" style={{ height: "90vh" }}>
                        <AgGrid table={table} />
                    </div>
                }
            />


            <DialogPassword
                password={password}
                setPassword={setPassword}
                display={showDialogPassword}
                onHide={() => setShowDialogPassword(false)}
                selected={selected}
                loading={loading}
                authPermiso={agregarFirma}
                showInput={true}
            />
        </div>
    );
};

export default NotasCreditoScreen;
